import React, { useMemo, useRef, useState } from 'react'
import Grid from '@material-ui/core/Grid'
import Switch from 'Components/Switch'

import Input from 'Components/Input'
import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import { InputAdornment } from "@material-ui/core";
import Utils from "EurestoFonction/Utils";

export default React.memo((props) => {


    const quantite = useRef(props.detail.quantite, [])
    const isHover = useRef(false, [])
    const [key, setKey] = useState(Utils.uuidv4(), [])

    const uuid = useMemo(() => Utils.uuidv4(), [])

    const onChange = (q) => {
        quantite.current = q
        props.onChange(q, 'quantite')
        setKey(Utils.getRandomNumber())
    }

    /*useEffect(() => {
        if(props.detail.etape === 1){
            const elem = document.getElementById(`etape-${uuid}`)
            elem.addEventListener("mouseenter", (e) => {
                isHover.current = true
                setKey(Utils.uuidv4())
            })
            elem.addEventListener("mouseleave", (e) => {
                isHover.current = false
                setKey(Utils.uuidv4())
            })
        }
    }, [])*/

    return <Grid container
        key={props.key}
        id={`etape-${uuid}`}
        className={props.detail.etape === 0 && (props.detail.produit_id === undefined || props.detail.produit_id === null) && 'commentaire'
            || props.detail.etape === 1 && `etape`
            || props.detail.produit_id && 'produit-' + props.detail.type_produit_id || ''}
        style={{
            margin: `2.5px ${props.lastIndexStepFound === -1 ? 0 : 20}px`,
            width: `calc(100% - ${props.lastIndexStepFound === -1 ? 0 : 20}px)`,
            borderRadius: 5,
            padding: 0,
            border: props.detail.delete && '3px solid #F05D5E' || '1px solid lightgray'
        }}
        spacing={0} alignItems={'center'}>
        <Grid item style={{ margin: 0, padding: 2.5, width: props.lastIndexStepFound === -1 ? 40 : 20 }}>
            <Grid container justify={"center"} alignContent={"center"} alignItems={"center"}
                style={{ margin: 0, padding: 0, fontSize: props.lastIndexStepFound === -1 ? 20 : 15 }} className={' ' +
                    (props.detail.etape === 1 && 'ei-commun_drapeau_plein'
                        || (props.detail.etape === 0 && !props.detail.produit_id && 'ei-commun_commentaire'))}>{props.index || ''}</Grid>
        </Grid>
        {
            props.detail.etape === 0 && (props.detail.produit_id === undefined || props.detail.produit_id === null) &&
            <Grid item style={{ margin: 0, padding: 2.5 }} xs>
                <Traduction
                    disabled={props.detail.delete}
                    multi
                    height={'auto'}
                    rowsMax={4}
                    style={{ marginBottom: 0 }}
                    onChange={props.onChange}
                    name={'commentaire'}
                    placeholder={EurestoI18n.t('Commentaire')}
                    data={props.detail.commentaire}
                    type={Constants.typeSaisie.SaisieLibre}
                />
            </Grid>
            ||
            props.detail.etape === 1 &&
            <React.Fragment>
                <Grid item style={{ margin: 0, padding: 2.5 }} xs>
                    <Traduction
                        disabled={props.detail.delete}
                        onChange={props.onChange}
                        style={{ marginBottom: 0, width: 'calc(100% - 483px)', minWidth: 160 }}
                        name={'libelle'}
                        placeholder={EurestoI18n.t('Étape')}
                        data={props.detail.libelle}
                        type={Constants.typeSaisie.SaisieLibre} />
                </Grid>
                {/*<Grid item style={{margin: 0, padding: 2.5}} xs>
                    {!props.disabled && isHover.current && <InputSearch
                        autoFocus={true}
                        menuMaxHeight={196}
                        placeholder={EurestoI18n.t('commun:Ajouter : Produit/Commentaire/Étape')}
                        disabled={props.detail.delete}
                        style={{marginBottom: 0}}
                        optionsPosition={'last'}
                        limit={5}
                        options={[{
                            label: 'Étape',
                            value: 0,
                            html:
                                <Grid container justify={'center'} alignContent={'center'} alignItems={'center'}>
                                    <i className={'ei-commun_ajouter EurestoPrimary EurestoText--text'} style={{
                                        padding: '4px 3px 3px 3px',
                                        borderRadius: '50%',
                                        fontSize: 8,
                                        fontWeight: 'bold'
                                    }}/>&nbsp;
                                    <strong>Étape</strong></Grid>,
                            onClick: props.addEtapeCommentaire,
                            resetOnClicked: true
                        }, {
                            label: 'Commentaire',
                            value: -1,
                            html:
                                <Grid container justify={'center'} alignContent={'center'} alignItems={'center'}>
                                    <i className={'ei-commun_ajouter EurestoPrimary EurestoText--text'} style={{
                                        padding: '4px 3px 3px 3px',
                                        borderRadius: '50%',
                                        fontSize: 8,
                                        fontWeight: 'bold'
                                    }}/>&nbsp;
                                    <strong>Commentaire</strong></Grid>,
                            onClick: props.addEtapeCommentaire,
                            resetOnClicked: true
                        }]}
                        onChange={props.addProduitDetail} path={'gestion'} requete={'produit'} search={'libelle'}
                        id={'id'}
                        resetInput={Utils.uuidv4()}/>}
                </Grid>*/}
            </React.Fragment>
            ||
            (props.detail.etape === 2 || (props.detail.etape === 0 && props.detail.produit_id !== undefined && props.detail.produit_id !== null)) &&
            <React.Fragment>
                <Grid item style={{ margin: 0, padding: 2.5, width: `calc(100% - 583px)`, minWidth: 180 }}>
                    <Grid container spacing={0} style={{ margin: 0, padding: 0 }} direction={'column'} alignContent={'space-between'}>
                        <Input
                            disabled
                            style={{ marginBottom: 5 }}
                            name="produit_libelle"
                            inputStyle={props.detail.delete && { textDecorationLine: 'line-through' }}
                            type="text"
                            className="upText"
                            value={props.detail.produit_libelle}
                        />
                        <Traduction
                            disabled={props.detail.delete}
                            multi
                            placeholder={EurestoI18n.t('commun:Commentaire')}
                            height={'auto'}
                            rowsMax={4}
                            inputStyle={{ color: EurestoColor('EurestoError'), fontStyle: 'italic', fontSize: 10 }}
                            style={{ marginBottom: 0 }}
                            onChange={props.onChange}
                            name={'commentaire'}
                            placeholder={EurestoI18n.t('Commentaire')}
                            data={props.detail.commentaire}
                            type={Constants.typeSaisie.SaisieLibre}
                        />
                    </Grid>
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 125 }}>
                    <Input
                        disabled={props.detail.delete}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">
                                &nbsp;{props.detail.libelle_part_unite && ('x' + props.detail.part + ' ' + props.detail.libelle_part_unite) || props.detail.libelle_unite}
                            </InputAdornment>
                        }}
                        autoFocus={props.autofocus}
                        inputStyle={{ textAlign: 'right' }}
                        style={{ marginBottom: 0 }}
                        onChange={onChange}
                        name="quantite"
                        type="text"
                        className="upText"
                        value={quantite.current}
                    />
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 70 }}>
                    <Input
                        disabled={props.detail.delete}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">&nbsp;%</InputAdornment>
                        }}
                        inputStyle={{ textAlign: 'right' }}
                        style={{ marginBottom: 0 }}
                        onChange={props.onChange}
                        name="taux_perte"
                        type="text"
                        className="upText"
                        value={props.detail.taux_perte}
                    />
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 125 }}>
                    <Input
                        InputProps={{
                            endAdornment: <InputAdornment position="end">
                                &nbsp;€/{props.detail.libelle_part_unite || props.detail.libelle_unite}
                            </InputAdornment>
                        }}
                        inputStyle={{ textAlign: 'right' }}
                        style={{ marginBottom: 0 }}
                        disabled
                        type="text"
                        className="upText"
                        value={props.detail.prix}
                    />
                </Grid>
                <Grid item style={{ margin: 0, padding: 2.5, width: 120 }}>
                    <Input
                        key={key}
                        InputProps={{
                            endAdornment: <InputAdornment position="end">
                                &nbsp;€
                            </InputAdornment>
                        }}
                        inputStyle={{ textAlign: 'right' }}
                        style={{ marginBottom: 0 }}
                        disabled
                        type="text"
                        className="upText"
                        value={Math.round(props.detail.prix * quantite.current * 1000) / 1000}
                    />
                </Grid>
                <Grid item style={{ margin: "0px 2.5px 0px 10px", padding: 2.5, width: 30 }}>
                    <Grid container direction={"column"} justify={"center"} alignContent={"center"} alignItems={"center"}
                        style={{ margin: 0, padding: 0 }} spacing={0}>
                        <Switch inline title={false} onChange={(data, name) => {
                            props.onChange(Math.abs((props.detail.pour_memoire || 0) - 1), 'pour_memoire')
                        }}
                            disabled={props.detail.delete}
                            checked={props.detail.pour_memoire === 1} />
                    </Grid>
                </Grid>
            </React.Fragment>
        }
        <Grid item style={{ margin: 0, padding: 2.5, width: 30 }}>
            {!props.disabled && <Grid container justify={"center"} alignContent={"center"} alignItems={"center"}
                style={{ margin: 0, padding: 2.5, fontSize: 20 }} onClick={(e) => {
                    props.onDelete(e)
                }}
                className={`${!props.detail.delete && 'ei-commun_supprimer EurestoError--text' || 'ei-commun_fermer EurestoError--text'} cursor-pointer`} />}
        </Grid>
        <Grid item style={{ margin: 0, padding: 2.5, width: 30 }}>
            {!props.disabled && <Grid container direction={'column'} alignContent={"space-between"}>
                <i className={'ei-commun_chevron_up'}
                    onClick={() => props.i > 0 && props.move(-1)}
                    style={{
                        cursor: 'pointer',
                        fontSize: 15,
                        color: props.i > 0 && EurestoColor('EurestoPrimary') || 'transparent'
                    }} />
                <i className={'ei-commun_chevron_down'}
                    onClick={() => !props.lastIndex && props.move(1)}
                    style={{
                        cursor: 'pointer',
                        fontSize: 15,
                        color: !props.lastIndex && EurestoColor('EurestoPrimary') || 'transparent'
                    }} />
            </Grid>}
        </Grid>
    </Grid>
})


// WEBPACK FOOTER //
// ./app/App/Module/Gestion/Component/Details/Detail.js